/* Add-on guard: the salt shakers are add-on-only. Block all checkout paths when
   the cart contains a shaker (add-on) but no main product to attach it to. */
(function () {
  var ADDON_HANDLES = ['french-celtic-sea-salt-fine-ground-8oz-shaker'];
  var ADDON_PRODUCT_IDS = [9617519673591];
  var MESSAGE = 'Shakers are an add-on — please add Celtic Sea Salt to your order to check out.';

  var blocked = false;

  function getCart(cb) {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(cb)
        .catch(function () { xhr(cb); });
    } catch (e) { xhr(cb); }
  }
  function xhr(cb) {
    try {
      var x = new XMLHttpRequest();
      x.open('GET', '/cart.js', true);
      x.onreadystatechange = function () {
        if (x.readyState === 4 && x.status === 200) { try { cb(JSON.parse(x.responseText)); } catch (e) {} }
      };
      x.send();
    } catch (e) {}
  }

  function isAddon(item) {
    return ADDON_HANDLES.indexOf(item.handle) !== -1 || ADDON_PRODUCT_IDS.indexOf(item.product_id) !== -1;
  }

  function evaluate(cart) {
    if (!cart || !cart.items || cart.items.length === 0) { blocked = false; apply(); return; }
    var hasAddon = false, hasRegular = false;
    cart.items.forEach(function (it) { if (isAddon(it)) { hasAddon = true; } else { hasRegular = true; } });
    blocked = hasAddon && !hasRegular;
    apply();
  }

  function checkoutEls() {
    return [].slice.call(document.querySelectorAll(
      '[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button, ' +
      'button[name="checkout"], .additional-checkout-buttons, .cart__dynamic-checkout-buttons, ' +
      '.shopify-payment-button'
    ));
  }

  function apply() {
    checkoutEls().forEach(function (el) {
      if (blocked) {
        el.setAttribute('data-addon-blocked', '1');
        el.setAttribute('disabled', 'disabled');
        el.style.opacity = '0.5';
        el.style.pointerEvents = 'none';
        el.setAttribute('aria-disabled', 'true');
      } else if (el.getAttribute('data-addon-blocked')) {
        el.removeAttribute('data-addon-blocked');
        el.removeAttribute('disabled');
        el.style.opacity = '';
        el.style.pointerEvents = '';
        el.removeAttribute('aria-disabled');
      }
    });
    showNotes();
  }

  function showNotes() {
    // Place a message next to each regular checkout button.
    document.querySelectorAll('[name="checkout"], #CartDrawer-Checkout').forEach(function (btn) {
      var container = btn.closest('.cart__ctas, .cart__footer, #main-cart-footer, form') || btn.parentElement;
      if (!container) return;
      var note = container.querySelector('.addon-guard-note');
      if (blocked) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'addon-guard-note';
          note.style.cssText = 'margin:8px 0;padding:10px 12px;border-radius:8px;background:#fdecec;color:#b3261e;font-size:13px;line-height:1.4;text-align:center;';
          note.textContent = MESSAGE;
          btn.parentNode.insertBefore(note, btn);
        }
      } else if (note) {
        note.remove();
      }
    });
  }

  // Backstop: intercept clicks on any checkout control while blocked.
  document.addEventListener('click', function (e) {
    if (!blocked) return;
    var el = e.target.closest('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button, .shopify-payment-button, .additional-checkout-buttons, .cart__dynamic-checkout-buttons');
    if (el) { e.preventDefault(); e.stopPropagation(); alert(MESSAGE); }
  }, true);

  // Also guard the checkout form submit.
  document.addEventListener('submit', function (e) {
    if (blocked && e.target && e.target.querySelector && e.target.querySelector('[name="checkout"]')) {
      e.preventDefault(); e.stopPropagation(); alert(MESSAGE);
    }
  }, true);

  // Derive block-state from the rendered cart line items (no fetch needed).
  // Works live as the cart drawer / cart page re-renders.
  function evaluateFromDOM() {
    var items = [].slice.call(document.querySelectorAll(
      '.cart-item, [class*="cart-item"], .cart__item, [class*="line-item"]'
    )).filter(function (el) { return el.querySelector('a[href*="/products/"]'); });
    // De-dupe by the product link (some wrappers repeat).
    var seen = {}, links = [];
    items.forEach(function (el) {
      var a = el.querySelector('a[href*="/products/"]');
      if (!a) return;
      var href = a.getAttribute('href').split('?')[0];
      if (!seen[el === el ? href + '::' + (el.className || '') : href]) {} // noop
      links.push(href);
    });
    if (links.length === 0) return null; // can't tell from DOM
    var hasAddon = false, hasRegular = false;
    links.forEach(function (href) {
      var isAddonLink = ADDON_HANDLES.some(function (h) { return href.indexOf('/products/' + h) !== -1; });
      if (isAddonLink) hasAddon = true; else hasRegular = true;
    });
    return hasAddon && !hasRegular;
  }

  function refresh() {
    // Prefer the authoritative cart, but fall back to DOM if fetch is unavailable.
    var domVerdict = evaluateFromDOM();
    if (domVerdict !== null) { blocked = domVerdict; apply(); }
    getCart(function (cart) { if (cart && cart.items) evaluate(cart); });
  }

  // Initial + react to cart changes.
  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);

  // Re-check whenever the cart drawer / cart page re-renders.
  var mo = new MutationObserver(function () {
    var v = evaluateFromDOM();
    if (v !== null) { blocked = v; apply(); }
    clearTimeout(mo._t); mo._t = setTimeout(refresh, 150);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Re-check after any add/change/update request completes.
  ['pageshow', 'focus'].forEach(function (ev) { window.addEventListener(ev, refresh); });
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:updated', refresh);
})();
